import { FiUser, FiMail, FiPhone } from "react-icons/fi";
import { cn } from "utils/helpers";

interface BaseProps {
	marginBottom?: "2" | "4";
	marginTop?: "2" | "4";
}

interface RfxLead {
	email: string;
	fullName: string;
	phoneNumber?: string;
}

type RfxLeadInfoBoxProps =
	| (BaseProps & {
		email?: never;
		fullName?: never;
		phoneNumber?: never;
		rfxLead: RfxLead;
	})
	| (BaseProps & {
		email: string;
		fullName: string;
		phoneNumber?: string;
		rfxLead?: never;
	});

export const RfxLeadInfoBox: React.FC<RfxLeadInfoBoxProps> = ({
	fullName,
	marginBottom,
	marginTop,
	email,
	phoneNumber,
	rfxLead,
}) => {

	const displayName = rfxLead ? rfxLead.fullName : fullName;
	const displayEmail = rfxLead ? rfxLead.email : email;
	const displayPhone = rfxLead?.phoneNumber ?? phoneNumber;

	return (
		<div
			className={cn("rounded-lg border border-gray-200 bg-gray-50 px-4 py-3"
				, marginBottom && `mb-${marginBottom}`
				, marginTop && `mt-${marginTop}`
			)}
			data-testid="rfx-lead-info-box"
		>
			<p className="mb-2 text-xs font-medium uppercase tracking-wider text-gray-400">
				RFx Lead
			</p>
			<div className="flex flex-wrap items-center gap-x-4 gap-y-1.5">
				<span className="inline-flex items-center gap-1.5 text-sm text-gray-900">
					<FiUser size={14} className="text-gray-400" aria-hidden="true" />
					{displayName}
				</span>
				<a
					href={`mailto:${displayEmail}`}
					className="inline-flex items-center gap-1.5 text-sm text-[#0031DD] hover:underline"
				>
					<FiMail size={14} aria-hidden="true" />
					{displayEmail}
				</a>
				{(displayPhone) && (
					<span className="inline-flex items-center gap-1.5 text-sm text-gray-600">
						<FiPhone size={14} className="text-gray-400" aria-hidden="true" />
						{displayPhone}
					</span>
				)}
			</div>
		</div>
	);
};
